import React, { useEffect, useState, useCallback } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { fetchInvestor } from "../../../store/Slices/InvestorSlice";
import { InvestorColumns } from "../../../assets/Columns/InvestorColumns";
import SearchableTable from "../../../components/Tables/SearchableTable";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import CreateInvestorModal from "../../../components/Modals/CreateInvestorModal";
import EditInvestorModal from "../../../components/Modals/EditInvestorModal";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { DeleteInvestorApi } from "../../../ApiRequests";
import { ErrorToast, SuccessToast } from "../../../utils/ShowToast";
import AddInvestmentModal from "../../../components/Modals/AddInvestmentModal";
import { useParams } from "react-router-dom";
import { fetchInvestments } from "../../../store/Slices/InvestmentsSlice";
import { InvestmentColumns } from "../../../assets/Columns/InvestmentColumns";
import { usePageRefresh } from "../../../hooks/usePageRefresh";

const Investments = () => {
  const { id } = useParams();
  const [SearchText, setSearchText] = useState("");
  const [Loading, setLoading] = useState(false);
  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState(null);
  const [OpenCreateModal, setOpenCreateModal] = useState(false);
  const [OpenInvestmentModal, setOpenInvestmentModal] = useState(false);

  const dispatch = useDispatch();
  const InvestmentState = useSelector((state) => state.Investments);

  useEffect(() => {
    dispatch(fetchInvestments(id));
  }, [dispatch, id]);

  const refreshInvestments = useCallback(() => {
    dispatch(fetchInvestments(id));
  }, [dispatch, id]);

  usePageRefresh(refreshInvestments, [id]);
  return (
    <BodyWrapper>
      <Header title="Investments" desc="Overview of your investments"></Header>
      <div className="w-full mt-10 flex justify-center items-center">
        {InvestmentState.loading ? (
          <div className="flex flex-1 justify-center items-center">
            <FetchingLoading />
          </div>
        ) : (
          InvestmentState.data.length !== 0 && (
            <SearchableTable
              setOpenEditModal={setOpenEditModal}
              setOpenDeleteModal={setOpenDeleteModal}
              setSelected={setSelected}
              SearchPlaceholder={"Search Investor Name..."}
              SearchText={SearchText}
              setSearchText={setSearchText}
              CurrentData={InvestmentState.data}
              //   CurrentData={CategoryState.data.filter((dt) =>
              //     SearchText === ""
              //       ? true
              //       : dt.title.toLowerCase().startsWith(SearchText.toLowerCase())
              //   )}
              Columns={InvestmentColumns}
            />
          )
        )}
      </div>
    </BodyWrapper>
  );
};

export default Investments;
